<template>
  <div>
    <b-row>
      <b-col>
        <b-modal
          id="modal-scrollable"
          class="kanban-modal"
          scrollable
          size="lg"
          ref="openModal"
          :title="$t('geral.filtersAdvanced')"
          @show="modalReset"
          @hidden="modalReset"
          @ok="modalOk"
        >
          <div>
            <!-- <div>
          {{ "filterApplied" }}
          {{ filterApplied }}
            </div> -->
            <div>
              <label class="ml-3 mb-0"
                >{{ $t("tracking.cargo.client") }}:</label
              >
              <b-form-tags
                v-model="filter.client"
                no-outer-focus
                class="mt-0 form-control-tag"
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    addTag,
                    removeTag,
                  }"
                >
                  <b-input-group class="mb-0">
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :placeholder="$t('geral.pressEnterToAdd')"
                      class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addTag()" variant="secundary">
                        {{ $t("geral.add") }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-inline-block">
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      class="mr-1 btn-tag btn-sm btn-white btn-simple"
                    >
                      {{ tag }}
                    </b-form-tag>
                  </div>
                </template>
              </b-form-tags>
            </div>

            <div>
              <label class="ml-3 mb-0"
                >{{ $t("tracking.cargo.companyBranchName") }}:</label
              >
              <b-form-tags
                v-model="filter.branchName"
                no-outer-focus
                class="mt-0 form-control-tag"
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    addTag,
                    removeTag,
                  }"
                >
                  <b-input-group class="mb-0">
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :placeholder="$t('geral.pressEnterToAdd')"
                      class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addTag()" variant="secundary">
                        {{ $t("geral.add") }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-inline-block">
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      class="mr-1 btn-tag btn-sm btn-white btn-simple"
                    >
                      {{ tag }}
                    </b-form-tag>
                  </div>
                </template>
              </b-form-tags>
            </div>

            <div>
              <label class="ml-3 mb-0"
                >{{ $t("tracking.cargo.dateDeliveryForecast") }}:</label
              >
              <b-form-tags
                v-model="filter.dateDeliveryForecast"
                no-outer-focus
                class="mt-0 form-control-tag"
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    addTag,
                    removeTag,
                  }"
                >
                  <b-input-group class="mb-0">
                    <b-form-input
                      type="date"
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :placeholder="$t('geral.pressEnterToAdd')"
                      class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addTag()" variant="secundary">
                        {{ $t("geral.add") }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-inline-block">
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      class="mr-1 btn-tag btn-sm btn-white btn-simple"
                    >
                      {{ dateToString(tag) }}
                    </b-form-tag>
                  </div>
                </template>
              </b-form-tags>
            </div>

            <div>
              <label class="ml-3 mb-0"
                >{{ $t("tracking.cargo.dateAttendanceExpiration") }}:</label
              >
              <b-form-tags
                v-model="filter.dateAttendanceExpiration"
                no-outer-focus
                class="mt-0 form-control-tag"
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    addTag,
                    removeTag,
                  }"
                >
                  <b-input-group class="mb-0">
                    <b-form-input
                      type="date"
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :placeholder="$t('geral.pressEnterToAdd')"
                      class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addTag()" variant="secundary">
                        {{ $t("geral.add") }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-inline-block">
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      class="mr-1 btn-tag btn-sm btn-white btn-simple"
                    >
                      {{ dateToString(tag) }}
                    </b-form-tag>
                  </div>
                </template>
              </b-form-tags>
            </div>

            <div>
              <label class="ml-3 mb-0"
                >{{ $t("tracking.cargo.origin") }}:</label
              >
              <b-form-tags
                v-model="filter.origin"
                no-outer-focus
                class="mt-0 form-control-tag"
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    addTag,
                    removeTag,
                  }"
                >
                  <b-input-group class="mb-0">
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :placeholder="$t('geral.pressEnterToAdd')"
                      class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addTag()" variant="secundary">
                        {{ $t("geral.add") }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-inline-block">
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      class="mr-1 btn-tag btn-sm btn-white btn-simple"
                    >
                      {{ tag }}
                    </b-form-tag>
                  </div>
                </template>
              </b-form-tags>
            </div>

            <div>
              <label class="ml-3 mb-0"
                >{{ $t("tracking.cargo.destination") }}:</label
              >
              <b-form-tags
                v-model="filter.destination"
                no-outer-focus
                class="mt-0 form-control-tag"
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    addTag,
                    removeTag,
                  }"
                >
                  <b-input-group class="mb-0">
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :placeholder="$t('geral.pressEnterToAdd')"
                      class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addTag()" variant="secundary">
                        {{ $t("geral.add") }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-inline-block">
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      class="mr-1 btn-tag btn-sm btn-white btn-simple"
                    >
                      {{ tag }}
                    </b-form-tag>
                  </div>
                </template>
              </b-form-tags>
            </div>

            <div>
              <label class="ml-3 mb-0"
                >{{ $t("tracking.cargo.vehiclePlate") }}:</label
              >
              <b-form-tags
                v-model="filter.vehiclePlate"
                no-outer-focus
                class="mt-0 form-control-tag"
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    addTag,
                    removeTag,
                  }"
                >
                  <b-input-group class="mb-0">
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :placeholder="$t('geral.pressEnterToAdd')"
                      class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addTag()" variant="secundary">
                        {{ $t("geral.add") }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-inline-block">
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      class="mr-1 btn-tag btn-sm btn-white btn-simple"
                    >
                      {{ tag }}
                    </b-form-tag>
                  </div>
                </template>
              </b-form-tags>
            </div>

            <div>
              <label class="ml-3 mb-0"
                >{{ $t("tracking.cargo.driver") }}:</label
              >
              <b-form-tags
                v-model="filter.driver"
                no-outer-focus
                class="mt-0 form-control-tag"
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    addTag,
                    removeTag,
                  }"
                >
                  <b-input-group class="mb-0">
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :placeholder="$t('geral.pressEnterToAdd')"
                      class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addTag()" variant="secundary">
                        {{ $t("geral.add") }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-inline-block">
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      class="mr-1 btn-tag btn-sm btn-white btn-simple"
                    >
                      {{ tag }}
                    </b-form-tag>
                  </div>
                </template>
              </b-form-tags>
            </div>
            <div>
              <label class="ml-3 mb-0"
                >{{ $t("tracking.cargo.dateAttendance") }}:</label
              >
              <b-form-tags
                v-model="filter.dateAttendance"
                no-outer-focus
                class="mt-0 form-control-tag"
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    addTag,
                    removeTag,
                  }"
                >
                  <b-input-group class="mb-0">
                    <b-form-input
                      type="date"
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :placeholder="$t('geral.pressEnterToAdd')"
                      class="form-control"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addTag()" variant="secundary">
                        {{ $t("geral.add") }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="d-inline-block">
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      class="mr-1 btn-tag btn-sm btn-white btn-simple"
                    >
                      {{ tag }}
                    </b-form-tag>
                  </div>
                </template>
              </b-form-tags>
            </div>
          </div>
          <template #modal-footer="{ ok, cancel }">
            <div class="right">
              <b-button variant="green" @click="ok()">
                {{ $t("geral.confirm") }}
              </b-button>
              <b-button class="ml-2" variant="danger" @click="cancel()">
                {{ $t("geral.cancel") }}
              </b-button>
            </div>
          </template>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      filter: {
        client: [],
        branchName: [],
        dateDeliveryForecast: [],
        dateAttendanceExpiration: [],
        origin: [],
        destination: [],
        vehiclePlate: [],
        driver: [],
        dateAttendance: [],
        driverPersonalDocument: [],
      },
      filterApplied: {
        client: [],
        branchName: [],
        dateDeliveryForecast: [],
        dateAttendanceExpiration: [],
        origin: [],
        destination: [],
        vehiclePlate: [],
        driver: [],
        dateAttendance: [],
        driverPersonalDocument: [],
      },
    };    
  },
  created() {
    this.getFilterApplied();
  },

  methods: {
    modalOpen() {
      this.$refs.openModal.show();
    },
    async postFilterApplied() {
      let filters = {
        appliedFilters: JSON.stringify(this.filter),
      };
      this.$api
        .post("/v1/cargo/filtersApplied", filters)
        .then((response) => {
          this.filterApplied = JSON.parse(response.data.appliedFilters);
          this.$emit("filter-confirm", this.filterApplied);
        })
        .catch((error) => {
          console.log("Error ");
          console.log(error);
          console.log(error.response.data.errors);
        });
    },
    async getFilterApplied() {
      this.$api
        .get("/v1/cargo/filters")
        .then((response) => {
          let model = JSON.parse(response.data.appliedFilters);
          this.filterApplied = model;
          this.$emit("filter-confirm", this.filterApplied);
        })
        .catch((error) => {
          // this.filterApplied = {};
          console.log("Error ");
          console.log(error);
          console.log(error.response.data.errors);
        });
    },
    modalReset() {
      this.filter.client = Array.from(this.filterApplied.client);
      this.filter.branchName = Array.from(this.filterApplied.branchName);
      this.filter.dateDeliveryForecast = Array.from(
        this.filterApplied.dateDeliveryForecast
      );
      this.filter.dateAttendanceExpiration = Array.from(
        this.filterApplied.dateAttendanceExpiration
      );
      this.filter.origin = Array.from(this.filterApplied.origin);
      this.filter.destination = Array.from(this.filterApplied.destination);
      this.filter.vehiclePlate = Array.from(this.filterApplied.vehiclePlate);
      this.filter.driver = Array.from(this.filterApplied.driver);
      this.filter.dateAttendance = Array.from(
        this.filterApplied.dateAttendance
      );
    },
    modalOk() {
      this.filterApplied.client = Array.from(this.filter.client);
      this.filterApplied.branchName = Array.from(this.filter.branchName);
      this.filterApplied.dateDeliveryForecast = Array.from(
        this.filter.dateDeliveryForecast
      );
      this.filterApplied.dateAttendanceExpiration = Array.from(
        this.filter.dateAttendanceExpiration
      );
      this.filterApplied.origin = Array.from(this.filter.origin);
      this.filterApplied.destination = Array.from(this.filter.destination);
      this.filterApplied.vehiclePlate = Array.from(this.filter.vehiclePlate);
      this.filterApplied.driver = Array.from(this.filter.driver);
      this.filterApplied.dateAttendance = Array.from(
        this.filter.dateAttendance
      );
      this.postFilterApplied();
    },
    dateToString(value) {
      let date = new Date(`${value} 00:00:00`);
      return date.toLocaleDateString();
    },    
  },
};
</script>

<style scoped>
.btn-checklist {
  min-width: 95px;
}
.right {
  text-align: right;
  width: 100%;
}

.btn-tag {
  font-size: 0.875rem;
}
.form-control-tag {
  border: none;
}
.kanban-modal {
  z-index: 1060;
}
.search-icon {
  background: #2c3b5d;
  width: 3rem;
  height: 100%;
  padding-top: 8px;
  text-align: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
</style>
